import { lazy } from 'react'

export const TopikLevelPage = lazy(() => import('./TopikLevel'))
export const TopikMaterialPage = lazy(() => import('./TopikMaterial'))
export const TopikLevelAddPage = lazy(() => import('./TopikLevelAdd'))
export const TopikLevelEditPage = lazy(() => import('./TopikLevelEdit'))
export const StudyMaterialPage = lazy(() => import('./StudyMaterial'))
export const StudyMaterialAddPage = lazy(() => import('./StudyMaterialAdd'))
export const StudyMaterialEditPage = lazy(() => import('./StudyMaterialEdit'))